import React from 'react'

export default function Hero() {
  return (
    <>
      <div className='main lg:h-[1032px] md:h-[720px] h-[300px]'></div>
    </>
  )
}
